import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/i18n";

const IDLE_MS = 30 * 60 * 1000;
const WARN_MS = 60 * 1000;
const KEY = "tt_last_activity";
const TOAST_ID = ["idle", "warning"].join("-");
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];

export function IdleLogout() {
  const { user, signOut } = useAuth();
  const warned = useRef(false);
  useEffect(() => {
    if (sessionStorage.getItem("tt_idle_out")) {
      sessionStorage.removeItem("tt_idle_out");
      setTimeout(() => toast.info(t("You were signed out after 30 minutes of inactivity."), { duration: 8000 }), 300);
    }
  }, []);
  useEffect(() => {
    if (!user) return undefined;
    let last = 0;
    const touch = () => {
      const n = Date.now();
      if (n - last < 5000) return;
      last = n;
      localStorage.setItem(KEY, String(n));
      if (warned.current) { warned.current = false; toast.dismiss(TOAST_ID); }
    };
    touch();
    EVENTS.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const h = setInterval(() => {
      const idle = Date.now() - Number(localStorage.getItem(KEY) || Date.now());
      if (idle >= IDLE_MS) {
        toast.dismiss(TOAST_ID);
        signOut().then(() => { sessionStorage.setItem("tt_idle_out", "1"); window.location.assign("/login"); });
      } else if (idle >= IDLE_MS - WARN_MS && !warned.current) {
        warned.current = true;
        toast.warning(t("You will be signed out in 1 minute due to inactivity."), { id: TOAST_ID, duration: WARN_MS });
      }
    }, 10000);
    return () => { clearInterval(h); EVENTS.forEach((e) => window.removeEventListener(e, touch)); };
  }, [user, signOut]);
  return null;
}
